import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageShell, { PageHero } from "./PageShell";
import { infoPages } from "../content/pages";
import { useUI } from "../context/UIContext";

export default function InfoPage() {
  const location = useLocation();
  const key = location.pathname.replace(/^\//, "");
  const data = infoPages[key];
  const { openIllustration } = useUI();

  if (!data) return <Navigate to="/" replace />;


  return (
    <PageShell>
      <PageHero eyebrow={data.eyebrow} title={data.title} intro={data.intro} />
      <section className="bg-white py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-5 md:px-8">
          <div className="space-y-10">
            {data.sections.map((s, i) => (
              <div key={i} className="relative pl-6">
                <span className="absolute left-0 top-1.5 w-2.5 h-2.5 rounded-full bg-[#c2a15a]" />
                <h2 className="font-display text-[24px] md:text-[28px] text-[#0b1f3a]">
                  {s.h}
                </h2>
                <p className="text-[#0b1f3a]/65 text-[16px] leading-relaxed mt-3">
                  {s.p}
                </p>
              </div>
            ))}
          </div>

          {data.note && (
            <p className="mt-12 text-[13px] text-[#0b1f3a]/45 border-t border-[#0b1f3a]/8 pt-6 leading-relaxed">
              {data.note}
            </p>
          )}

          <button
            onClick={openIllustration}
            className="group mt-8 inline-flex items-center gap-2 bg-[#0b1f3a] hover:bg-[#163561] text-white font-semibold uppercase tracking-wide text-[14px] px-7 py-4 rounded-full transition-colors"
          >
            {data.cta}
            <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </section>
    </PageShell>
  );
}
